import EmptyState from 'Components/common/components/EmptyState';
import React from 'react';
import styled from 'styled-components';
import { LeaderboardSummary } from 'Types/SRITypes';
import {
  minWidthApp,
  secondaryFont, wMBold,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 80px;
  height: 350px;
  position: relative;
  &.header-stats {
   height:  auto;
   padding-bottom: 0px;
   text-align: center;
    .data-top-on-bar {
      padding: 0px 6px;
      font-weight: ${wMBold};
      font-family: ${secondaryFont};
      font-size: 15px;
      color: #424B50;
      span {
        margin-left: 5px;
      }
    }
  }
  .bar-item-header {
    &:nth-child(1) {
      border-left: 1px solid #D0D0D0;
    }
    height: auto;
    padding-bottom: 5px;
    border-top: 0px solid #D0D0D0;
    border-bottom: 1px solid #D0D0D0;
    border-right: 1px solid #D0D0D0;
    width: 150px;
    @media all and (max-width: ${minWidthApp}) {
      width: 140px;
    }
  }
  .item-wrap {
    height: 100%;
    position: relative;
    display: flex;
    align-items: flex-end;
    &:nth-child(1){ 
      .bar-item {
        background-color: rgba(255,72,73,0.7);
        &:before {
          border-left: 1px solid #D0D0D0;
        }
      }
    }
    &:nth-child(2){ 
      .bar-item {
       background-color: rgba(26,27,27,0.7);
       
      }
    }
    &:nth-child(3){ 
      .bar-item {
        background-color: rgba(19,99,197,0.7);
      }
    }
    &:nth-child(4){ 
      .bar-item {
         background-color: rgba(52,201,30,0.7);
      }
    }
    &:nth-child(5){ 
      .bar-item {
        background-color: rgba(255,209,71,0.7);
      }
    }
    &:nth-child(6){ 
      .bar-item {
        background-color: rgba(207,207,207,0.7)
      }
    }
  }
  .bar-item {
    height: 80%;
    width: 150px;
     @media all and (max-width: ${minWidthApp}) {
      width: 140px;
    }
    display: flex;
    align-items: flex-end;
    position: static;
    border: 1px solid #D0D0D0;
    &:before {
      content: "";
      border-right: 1px solid #D0D0D0;
      height: 100%;
      width: 150px;
       @media all and (max-width: ${minWidthApp}) {
      width: 140px;
    }
      position: absolute;
      display: block;
      top: 0px;
    }
    .data-top-on-bar {
      padding: 0px 6px;
      font-weight: ${wMBold};
      font-family: ${secondaryFont};
      font-size: 15px;
      color: #424B50;
      position: absolute;
      top: -25px;
      span {
        margin-left: 5px;
      }
    }
  }
  .belt-holder {
    width: 100px;
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
  }
  .belt-label {
    font-family: ${secondaryFont};
    font-weight: ${wMBold};
    color: #424B50;
    font-size: 18px;
    margin-bottom: 0px;
    position: absolute;
    bottom: -65px;
    text-align: center;
    width: 100%;
  }
`;

type Props = {
  data: LeaderboardSummary[],
};

const BeltChart = function BeltChart(props: Props) {
  const { data } = props;

  return (
    <div className="beltchart">
      {data.length === 0 ? (
        <EmptyState
          msg="No analytics data found"
          detail="Try adjusting your filters to find what you are looking for"
          height="380px"
        />
      )
        : (
          <>
            <Wrapper className="header-stats">
              {data?.map((belt) => (
                <div className="bar-item-header">
                  <div className="data-top-on-bar">
                    {belt.numbers}
                    <span>{`(${belt.percentage})`}</span>
                  </div>
                </div>
              ))}
            </Wrapper>
            <Wrapper>
              {data?.map((belt) => (
                <div className="item-wrap">
                  <div className="bar-item" style={{ height: belt.percentage }}>
                    <h6 className="belt-label">{belt.text}</h6>
                    <img src={belt.image} alt="belt-holder" className="belt-holder" />
                  </div>
                </div>
              ))}
            </Wrapper>
          </>
        )}
    </div>
  );
};

export default BeltChart;
